import cat from "../assets/animations/mouse/data.json";
import error from "../assets/animations/error/data.json";
import mouse from "../assets/animations/cat/data.json";
import spinner from "../assets/animations/spinner/data.json";

interface AnimationNames {
  spinner: any;
  error: any;
  mouse: any;
  cat: any;
}
const Animations: AnimationNames = {
  spinner,
  error,
  mouse,
  cat,
};

export default Animations;
